import { createFileRoute } from '@tanstack/react-router';

// Rendered by the parent `chat` route, which stays mounted while the thread changes.
export const Route = createFileRoute('/_authenticated/_shell/chat/$id')({});
